import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { BaseEntity, BaseState } from '@base/entities/BaseEntities';
import { AppConfigService } from '@configuration/app.config.service';
import { ScreenService } from '@core/framework/screen.service';
import { EnumApplicationMode, EnumPageDisplayModes, EnumWindowSizes, SysEnumsService } from '@core/framework/sysenums.enum';
import { ToolbarSettings } from '@m4u-angular/base/classes/BaseClasses';
import { BasePageCRUDComponent } from '@m4u-angular/base/component/BasePageCRUDComponent';
import { FrameworkService } from '@m4u-angular/core/framework/framework.service';
import { SysEventsService } from '@m4u-angular/core/framework/sysevents.service';
import { DxPopupComponent, DxScrollViewComponent } from 'devextreme-angular';
import { Subscription } from 'rxjs';

@Component({
    selector: 'm4u-page',
    templateUrl: './pagelayout.component.html',
    styleUrls: ['./pagelayout.component.scss', '../page-filter/page-filter.component.scss']
})
export class PageLayoutComponent implements OnInit, OnDestroy {

    @HostListener('document:keydown.escape', ['$event'])
    EscPress = (event: KeyboardEvent) => this.EscPressed(event);
    
    //sidebarOpened = false;
    //sidebarPinned = false;
    //FilterDescription = "";
    //Title = "";

    //ToolbarButtons: any[] = [];
    //IsAllowNotifications: boolean;
    private _isPageButtonsVisible: boolean;
    private _pageToolbarSettings: ToolbarSettings;
    private _subscriptions: Subscription[] = [];
    
    IsPageSidePanelVisible: boolean;
    ShowPreview: boolean;
    PreviewPDFData: string | Blob;
    PreviewFileName: string;
    
    @ViewChild('pageHeader') pageHeader: ElementRef;
    @ViewChild('popup') popup: DxPopupComponent;
    @ViewChild('scroll') scroll: DxScrollViewComponent;

    constructor(public screen: ScreenService,
        private appConfigService: AppConfigService,
        public SysEnums: SysEnumsService,
        private sysEvents: SysEventsService, 
        public screenService: ScreenService,
        private frameworkService: FrameworkService) {
    }

    @Input() public WindowHeight: EnumWindowSizes;
    @Input() public WindowWidth: EnumWindowSizes;
    @Input() public IsNoToolbar: boolean;
    @Input() public Class: string;
    @Input() public ShowScrollbar: string;
    @Input() ButtonsPosition: 'toolbar' | 'header';
    @Input() Page: BasePageComponent<BaseEntity, BaseState>;
    @Input() public ShowDialogAsWindow: boolean;
    @Input() public IsFooterHidden: boolean;

    @Input() SidePanelTemplate: TemplateRef<any>;
    @Input() ToolbarButtonsBefore: TemplateRef<any>;
    @Input() ToolbarButtonsAfter: TemplateRef<any>;
    @Input() QuickFilters: TemplateRef<any>;
    @Input() HeaderButtonsBefore: TemplateRef<any>;
    @Input() HeaderButtonsAfter: TemplateRef<any>;
    @Input() TitleButtons: TemplateRef<any>;

    //private m_Page: BasePageComponent<BaseEntity, BaseState>;
    //@Input() public set Page(value: BasePageComponent<BaseEntity, BaseState>) {
    //    if (this.m_Page != undefined) return;
    //    this.m_Page = value;
    //    this.OnAttachPage();
    //}

    //public get Page(): BasePageComponent<BaseEntity, BaseState> {
    //    return this.m_Page;
    //}

    //public get ClientHeight(): number {
    //    if (this.scroll == undefined) return 0;
    //    return this.scroll.instance.clientHeight();
    //}

    //public get ClientWidth(): number {
    //    if (this.scroll == undefined) return 0;
    //    return this.scroll.instance.clientWidth();//content().querySelector('.border').getBoundingClientRect().width;
    //}

    get ShowBreadBrumb() {
        return this.appConfigService.AppConfig.ShowBreadcrumb;
    }

    get Title() {
        return this._pageToolbarSettings?.Title;
    }

    get ShowBackButton() {
        return this._pageToolbarSettings?.ShowBackButton;
    }

    OnAttachPage() {
        //this.FilterDescription = this.Page.OnGetFilterDescription();
        //this.Page.PageLayout = this;
    }

    ngOnInit() {
        this._subscriptions.push(this.sysEvents.Toolbar.subscribe((toolbarSettings: ToolbarSettings) => {
            if (!toolbarSettings || this.Page.ComponentName !== toolbarSettings.PageComponentName) return;

            this._pageToolbarSettings = toolbarSettings;

            if (!this.ButtonsPosition) {
                this.ButtonsPosition = this.Page.DisplayMode == EnumPageDisplayModes.Window 
                    || this.Page.DisplayMode == EnumPageDisplayModes.Dialog
                    || this.Page instanceof BasePageCRUDComponent
                        ? 'toolbar'
                        : 'header';
            }

            const contextMenuItems = toolbarSettings.OnGetContextMenuItems();
            this._isPageButtonsVisible = toolbarSettings.IsAllowFilter || toolbarSettings.IsAllowPrint || toolbarSettings.IsAllowExport 
                || (contextMenuItems && contextMenuItems.length > 0);
        }));

        this._subscriptions.push(this.sysEvents.PageSidePanelState.subscribe(({pageComponentName, state}) => {
            if (pageComponentName != this.Page.ComponentName) return;

            this.IsPageSidePanelVisible = state;
        }));

        this._subscriptions.push(this.sysEvents.PagePreviewState.subscribe(({pageComponentName, state, data, fileName}) => {
            if (pageComponentName != this.Page.ComponentName) return;

            this.ShowPreview = state;
            this.PreviewPDFData = data;
            this.PreviewFileName = fileName;
        }));

        //this._subscriptions.push(this.sidebarService.SidebarState.subscribe(({SidebarName, State}) => {
        //    if (SidebarName === 'Filters') {
        //        this.IsFilterOpen = State === EnumSidebarStates.Opened;
        //    }
        //}))

        //if (!this.ButtonsPosition) this.ButtonsPosition = 'header';
        //this.sidebar$subscription = this.events.Sidebar
        //    .subscribe(result => {
        //        if (result.pageComponentName === this.Page.ComponentName || result.force) this.SetSidebarState(result.action);
        //    });

        //this.reloadToolbar$subscription = this.events.Toolbar.subscribe(() => {
        //    this.Title = this.Page.GetTitle();
        //    this.FilterDescription = this.Page.OnGetFilterDescription();
        //});
        //this.IsAllowNotifications = this.appConfigService.AppConfig.IsAllowNotifications
        //    && this.Page.DisplayMode == EnumPageDisplayModes.FullScreen;
    }

    GetPreviewTitle() {
        return this._pageToolbarSettings.OnGetPreviewTitle();
    }

    //InitInjectedComponents() {
    //    const componentFactoryResolver = AppInjector.get(ComponentFactoryResolver);

    //    SysGlobals.InjectableComponentsOptions.forEach(x => {
    //        if (x.TargetModuleName === this.Page.ModuleName && x.TargetComponentName === this.Page.ComponentName) {
    //            // Resolve an injectable component
    //            const componentFactory = componentFactoryResolver.resolveComponentFactory(x.ComponentType);
    //            const componentRef = this.containerRef.createComponent<BaseInjectableComponent<BaseEntity, BaseState>>(componentFactory);
    //            // Set fields
    //            componentRef.instance.TargetComponentName = this.Page.ComponentName;
    //            componentRef.instance.TargetAppName = this.Page.ModuleName;
    //            componentRef.instance.EntityType = this.Page.EntityType;

    //            // Handle the injectable component on high levels
    //            this.Page.OnInitInjectableComponent(componentRef.instance);

    //            if (this.screen.IsDesktop()) {
    //                // Add buttons to toolbar
    //                const buttonSettings = {
    //                    Type: 'normal',
    //                    Text: x.ButtonText,
    //                    Click: () => { componentRef.instance.BaseAction(); }
    //                };
    //                this.ToolbarButtons.push(buttonSettings);

    //                // Give buttons settings to ths injectable component
    //                componentRef.instance.ButtonSettings = buttonSettings;
    //            } else {
    //                this.Page.ContextMenuDefault.push({
    //                    text: x.ButtonText,
    //                    onClick: () => { componentRef.instance.BaseAction(); }
    //                });
    //            }
    //        }
    //    });
    //}

    ngOnDestroy() {
        this._subscriptions && this._subscriptions.forEach(x => x.unsubscribe());
        //this.sidebar$subscription.unsubscribe();
        //this.reloadToolbar$subscription.unsubscribe();
    }
        
    IsHeaderEmpty() {
        return this.IsQuickFiltersEmpty && !this.HasContent(this.pageHeader) && !(this.IsMobileTitleVisible());

        //return !this.HasContent(this.pageHeader) && !this.HasContent(this.quickFilters) 
        //    && !this.HasContent(this.headerButtons) && !this.HasContent(this.pageToolbarButtons?.element.nativeElement);
    }

    IsMobileTitleVisible() {
        return this.IsStandardApplicationMode() && this.screen.IsMobile() && this.Page.DisplayMode === EnumPageDisplayModes.FullScreen;
    }

    get IsQuickFiltersEmpty() {
        return !this.QuickFilters && !this.HeaderButtonsBefore && !this.HeaderButtonsAfter && (this.ButtonsPosition === 'toolbar' || !this._isPageButtonsVisible);
        //return !this.HasContent(this.quickFilters) && !this.HasContent(this.headerButtonsBefore) && !this.HasContent(this.headerButtonsAfter) 
        //    && (this.ButtonsPosition === 'toolbar' || !this._isPageButtonsVisible);
    }

    GetPageLoadingClass() {
        return this.Page.IsLoading ? "page-is-loading" : "";
    }

    GetCustomClass() {
        return (this.Class || '') + ` ${this.Page.ComponentName}` + ` ${this.GetPageLoadingClass()}`;
    }

    GetDialogClass() {
        return `m4u-popup ${this.GetPopupWidthClass()} ${this.GetCustomClass()} ${this.Page.ShowDialogAsBottomSheet ? 'm4u-bottom-sheet' : 'm4u-dialog'}`;
    }

    GetDialogWidth() {
        return this.Page.ShowDialogAsBottomSheet ? '100%' : this.GetPopupSize(this.WindowWidth);
    }

    GetDialogHeight() {
        const height = this.Page.ShowDialogAsBottomSheet ? this.GetBottomSheetHeight(this.WindowHeight) : this.ShowDialogAsWindow ? '100%' : this.GetPopupSize(this.WindowHeight);
        this.popup?.instance?.option('height', height);
        return height;
    }

    GetDialogPosition() {
        return this.Page.ShowDialogAsBottomSheet? 'bottom' : this.ShowDialogAsWindow ? this.GetPopupPosition() : 'center';
    }

    //Return relevant display classes when showing as window
    //public GetWindowClasses(): string {
    //    //No need for special classes if showing full screen
    //    if (this.Page.DisplayMode == EnumPageDisplayModes.FullScreen) return '';

    //    //Classes
    //    const windowClasses = this.IsShowAsFullScreen() ? 'WindowFullScreen' : this.GetWindowClassesSizes();

    //    //Return relevant classes accordingly
    //    return `m4u-popup ${windowClasses} ${this.GetCustomClass()} ${this.GetPageLoadingClass()}`;

    //}

    GetPopupSize(size: EnumWindowSizes) {
        if (this.IsShowAsFullScreen()) return '100%';

        switch (size) {
            case EnumWindowSizes.WindowXSmall: return '30%';
            case EnumWindowSizes.WindowSmall: return '40%';
            case EnumWindowSizes.WindowMedium: return '50%';
            case EnumWindowSizes.WindowLarge: return '75%';
            case EnumWindowSizes.WindowXLarge: return '90%';
            case EnumWindowSizes.WindowAutoSize: return this.WindowHeight == size ? 'auto' : '100%';
        }
    }

    GetBottomSheetHeight(size: EnumWindowSizes) {
        if (this.IsShowAsFullScreen()) return '100vh';

        switch (size) {
            case EnumWindowSizes.WindowXSmall: return '50dvh';
            case EnumWindowSizes.WindowSmall: return '60dvh';
            case EnumWindowSizes.WindowMedium: return '70dvh';
            case EnumWindowSizes.WindowLarge: return '80dvh';
            case EnumWindowSizes.WindowXLarge: return '95dvh';
            case EnumWindowSizes.WindowAutoSize: return '100dvh';
        }
    }

    GetWindowWidth(size: EnumWindowSizes) {
        if (this.IsShowAsFullScreen()) return '100%';

        const previewSize = this.ShowPreview ? this.GetPreviewSize(size) : '0px';
        switch (size) {
            case EnumWindowSizes.WindowXSmall: return `calc(${previewSize} + 30vw)`;
            case EnumWindowSizes.WindowSmall: return `calc(${previewSize} + 40vw)`;
            case EnumWindowSizes.WindowMedium: return `calc(${previewSize} + 50vw)`;
            case EnumWindowSizes.WindowLarge: return `calc(${previewSize} + 75vw)`;
            case EnumWindowSizes.WindowXLarge: return `calc(${previewSize} + 90vw)`;
            case EnumWindowSizes.WindowAutoSize: return '100%';
        }
    }

    GetPreviewSize(size: EnumWindowSizes) {
        switch (size) {
            case EnumWindowSizes.WindowXSmall: return '45vw';
            case EnumWindowSizes.WindowSmall: return '45vw';
            case EnumWindowSizes.WindowMedium: return '45vw';
            case EnumWindowSizes.WindowLarge: return '20vw';
            case EnumWindowSizes.WindowXLarge: return '10vw';
            case EnumWindowSizes.WindowAutoSize: return 0;
        }
    }

    GetPopupWidthClass() {
        switch (this.WindowWidth) {
            case EnumWindowSizes.WindowXSmall:
            case EnumWindowSizes.WindowSmall:
                return 'm4u-popup-small';
            case EnumWindowSizes.WindowMedium:
                return 'm4u-popup-medium';
            case EnumWindowSizes.WindowLarge:
            case EnumWindowSizes.WindowXLarge:
                return 'm4u-popup-large';
            case EnumWindowSizes.WindowAutoSize:
                return 'm4u-popup-auto';
        }
    }

    GetPopupPosition() {
        return this.screen.IsRTL() ? 'left top' : 'right top';
    }

    GetBottomSheetPosition() {
        return this.screen.IsRTL() ? 'right top' : 'left top';
    }

    GetPopupShowAnimation() {
        const direction = this.screen.IsRTL() ? 'left' : 'right';
        return { type: 'slideIn', direction: direction, duration: 250 };
    }

    GetPopupHideAnimation() {
        const direction = this.screen.IsRTL() ? 'left' : 'right';
        return { type: 'slideOut', direction: direction, duration: 250 };
    }

    GetBottomSheetShowAnimation() {
        return { type: 'slideIn', direction: 'bottom', duration: 400 };
    }

    GetBottomSheetHideAnimation() {
        return { type: 'slideOut', direction: 'bottom', duration: 400 };
    }

    //Returns whether current page should be shown as full screen
    //This is a major hub function that determines visibility of window and dialog (not so relevant to DisplayMode=FullScreen)
    //Basically:
    //DisplayMode=FullScreen - always rendered on full screen
    //DisplayMode=Window - rendered on full screen if screen is XSmall
    //DisplayMode=Dialog - rendered on full screen if screen is XSmall and the page itself is not of small dimensions.
    public IsShowAsFullScreen(): boolean {

        //Screen and current page sizes
        var bMobile: boolean = this.screen.IsMobile();
        var bSmallPage: boolean = (this.WindowHeight == EnumWindowSizes.WindowXSmall
            || this.WindowHeight == EnumWindowSizes.WindowSmall
            || this.WindowHeight == EnumWindowSizes.WindowAutoSize) && (this.WindowWidth == EnumWindowSizes.WindowXSmall);

        //No need for special classes if showing full screen, unless this is a mobile device
        if (this.Page.DisplayMode == EnumPageDisplayModes.FullScreen) return true;

        //For window - show full screen or in window according to screen size. Use window dimensions
        if (this.Page.DisplayMode == EnumPageDisplayModes.Window) return bMobile ? true : false;

        //For dialog - show always in partial view, unless this is a mobile device and the page is large
        if (this.Page.DisplayMode == EnumPageDisplayModes.Dialog) return false;//bMobile ? (bSmallPage ? false : true) : false;
    }

    //Return the dimension classes
    //GetWindowClassesSizes(): string {
    //    return (this.WindowWidth ? this.WindowWidth : EnumWindowSizes.WindowMedium) + '_W ' +
    //        (this.WindowHeight ? this.WindowHeight : EnumWindowSizes.WindowMedium) + '_H';
    //}

    //GetIsMobileFilterVisible() {
    //    return this.drawer && this.drawer.opened;
    //}

    //ApplyFilter() {
    //    this.events.FilterPanelAction(EnumFilterPanelActions.Apply);
    //    this.events.SidebarAction("FilterSidebar", this.Page.ComponentName, EnumSidebarActions.Close);
    //    this.FilterDescription = this.Page.OnGetFilterDescription();
    //}

    //ClearFilter() {
    //    this.events.FilterPanelAction(EnumFilterPanelActions.Clear);
    //    this.events.SidebarAction("FilterSidebar", this.Page.ComponentName, EnumSidebarActions.Close);
    //    this.FilterDescription = this.Page.OnGetFilterDescription();
    //}

    //PinFilter() {
    //    this.sidebarPinned = !this.sidebarPinned;
    //}

    OnPopupHiding(e) {
        e.cancel = true;
        this.Page.NavigateBack();
    }

    //OnPopupHidden(e) {
    //    this.Page.ClosePage();
    //}

    //Specify whether to render the toolbar
    public IsRenderToolbar(): boolean {
        return !this.IsNoToolbar && this.appConfigService.AppConfig.Mode !== EnumApplicationMode.IFrame;
    }

    IsStandardApplicationMode() {
        return this.appConfigService.AppConfig.Mode === EnumApplicationMode.Standard;
    }

    public IsShowNavbar() {
        return (this.Page.DisplayMode !== 'Dialog' && !(this.Page instanceof BasePageCRUDComponent) && this.screen.IsMobile())
            || ((this.Page as any).IsAllowNavbar &&  (this.Page as any).IsAllowNavbar());
    }

    OnSidePanelToggle() {
        this.IsPageSidePanelVisible = !this.IsPageSidePanelVisible;
        this.sysEvents.SetPageSidePanelState(this.Page.ComponentName, this.IsPageSidePanelVisible);
    }

    //SetSidebarState = (action: EnumSidebarActions) => {
    //    this.sidebarOpened = (action === EnumSidebarActions.Toggle)
    //        ? !this.sidebarOpened
    //        : action === EnumSidebarActions.Open;
    //}

    //GetSidebarPosition() {
    //    return this.screen.IsRTL() ? 'left' : 'right';
    //}

    HasContent(content: any) {
        return content && (content.childElementCount !== undefined ? content.childElementCount > 0 : content.nativeElement.childElementCount > 0);
    }

    OnNavigateHome() {
       //Go to home route
       if (!this.IsStandardApplicationMode() || !this._pageToolbarSettings.Page || this._pageToolbarSettings.Page.DisplayMode != EnumPageDisplayModes.FullScreen) return;
       this.frameworkService.NavigateDefault();
    }

    OnBack() {
        this._pageToolbarSettings.BackButtonClick();
    }

    EscPressed = (event: KeyboardEvent) => {
        const popupElement = this.GetPopupElement(event?.target as any);
        if (!popupElement?.classList?.contains(this.Page.ComponentName)) return;

        if (this.Page?.DisplayMode === EnumPageDisplayModes.Window || this.Page?.DisplayMode === EnumPageDisplayModes.Dialog) {
            this.Page.ClosePage();
        }
    }

    private GetPopupElement(el: Element) {
        if (!el) return null;
        if (el.classList.contains('m4u-popup')) return el;

        return this.GetPopupElement(el.parentElement);
    }

    //OnSidebarViewChanged(state: 'show' | 'hide') {
    //    this.events.SetSidebarStateChanged(state === 'show' ? EnumSidebarStates.Opened : EnumSidebarStates.Closed);
    //}
}
